const storage = () => sessionStorage;

const STORAGE_KEY_PREFIX = 'nc.globalFilter';

type GlobalFilterScope = 'classes' | 'sites';

const storageKey = (scope: GlobalFilterScope, publicUserId: string) => `${STORAGE_KEY_PREFIX}.${scope}.${publicUserId}`;

export const readStoredIds = (scope: GlobalFilterScope, publicUserId: string): string[] => {
  if (!publicUserId) return [];

  try {
    const raw = storage().getItem(storageKey(scope, publicUserId));
    if (!raw) return [];

    const parsed: unknown = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];

    return parsed.filter((id): id is string => typeof id === 'string');
  } catch {
    return [];
  }
};

export const writeStoredIds = (scope: GlobalFilterScope, publicUserId: string, ids: string[]): void => {
  if (!publicUserId) return;

  try {
    storage().setItem(storageKey(scope, publicUserId), JSON.stringify(ids));
  } catch {
    return;
  }
};
